import {
  Question,
  QuestionType,
  TransitionQuestion,
} from "@/commonTypes/question";
import { TransitionBlockType } from "@/commonTypes/transitionContentBlocks";
import { getAssetUrl } from "@/utils/assetUrl";

const preloadedImageUrls = new Set<string>();

function collectImageKeysFromBlocks(
  blocks: TransitionQuestion["contentBlocks"],
  imageKeys: Set<string>,
): void {
  for (const block of blocks) {
    if (block.type === TransitionBlockType.IMAGE) {
      imageKeys.add(block.imageKey);
    }
  }
}

export function getTransitionImageUrls(questions: Question[]): string[] {
  const imageKeys = new Set<string>();

  for (const question of questions) {
    if (question.questionType !== QuestionType.TRANSITION) {
      continue;
    }

    collectImageKeysFromBlocks(question.contentBlocks, imageKeys);

    for (const variant of question.variants ?? []) {
      collectImageKeysFromBlocks(variant.contentBlocks, imageKeys);
    }
  }

  return Array.from(imageKeys, (imageKey) =>
    getAssetUrl(`/images/transitions/${imageKey}.webp`),
  );
}

export function preloadTransitionImages(questions: Question[]): void {
  if (typeof window === "undefined") return;

  const urls = getTransitionImageUrls(questions);
  for (const url of urls) {
    if (preloadedImageUrls.has(url)) {
      continue;
    }

    const image = new Image();
    image.decoding = "async";
    image.src = url;
    preloadedImageUrls.add(url);
  }
}
